import ScrollableCardSection from './ScrollableCardSection/ScrollableCardSection';
import { Widgets } from './widgets.types';

export default function WidgetsMapper({
  widgets,
  onAction,
  addingWidgetKey,
  disableActions,
}: {
  widgets: Widgets;
  onAction: (payload: any, widgetKey: string) => void;
  addingWidgetKey: string | null;
  disableActions: boolean;
}) {
  if (!widgets || widgets.length === 0) return null;

  return (
    <div className="d-flex flex-column gap-4">
      {widgets.map((widget, index) => (
        <ScrollableCardSection
          key={index}
          widget={widget}
          onAction={onAction}
          addingWidgetKey={addingWidgetKey}
          parentIndex={index}
          disableActions={disableActions}
        />
      ))}
    </div>
  );
}
